import React from 'react';
import { useTranslation } from 'react-i18next';
import { rem } from '@good/ui/core';
import { PageHeader } from '@good/ui/templates';

import { CoverPhotoForm } from './cover-photo-form';

export const Gallery = () => {
  const { t } = useTranslation('', { keyPrefix: 'silService.serviceDetailsTabs.gallery' });

  return (
    <>
      <PageHeader title={t('title')} subtitle={t('description')} size='h2' mb={rem(24)} />
      <div className='flex flex-col gap-6 w-full'>
        <CoverPhotoForm />
      </div>
    </>
  );
};
